import { memo } from 'react';

const THINKING_VIDEOS = [
  '/athena-assets/thinking-videos/athena-thinking-01.mp4',
  '/athena-assets/thinking-videos/athena-thinking-02.mp4',
];

export const AthenaThinkingVideoBackground = memo(function AthenaThinkingVideoBackground({ index = 0 }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'hidden', background: '#020712' }}>
      <video
        key={index}
        autoPlay loop muted playsInline preload="auto"
        src={THINKING_VIDEOS[index % THINKING_VIDEOS.length]}
        style={{
          width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center',
          opacity: 0.5, filter: 'saturate(0.76) brightness(0.55) contrast(1.05)',
        }}
      />
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 48%, rgba(1,10,22,0.16) 0%, rgba(1,7,17,0.50) 72%, rgba(1,5,13,0.78) 100%)' }} />
    </div>
  );
});
